import { z } from 'zod';

import { BorrowerId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const EliteLoanExtensionFeesDocumentInvestorOptions = z.enum([
  'Toorak',
  'NBR',
  'RCN',
  'CT Accredited',
  'PRETIUM12M',
  'Ellington',
]);
export type EliteLoanExtensionFeesDocumentInvestorOptions = z.infer<
  typeof EliteLoanExtensionFeesDocumentInvestorOptions
>;

export const EliteLoanExtensionFeesInput = z.object({
  investorName: EliteLoanExtensionFeesDocumentInvestorOptions,
  feeAmount: z.number(),
  emailRecipients: z.array(zodBrandedUuid<BorrowerId>()),
});
export type EliteLoanExtensionFeesInput = z.infer<typeof EliteLoanExtensionFeesInput>;

export const CreateLoanExtensionFeesDocumentEvent = BaseLoanEvent.extend({
  type: z.literal('createLoanExtensionFeesDocument'),
  input: EliteLoanExtensionFeesInput, // If more lenders are added, make this a union
});
export type CreateLoanExtensionFeesDocumentEvent = z.infer<typeof CreateLoanExtensionFeesDocumentEvent>;
